<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Number Square</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-number-square-form ref="puzzleNumberSquareForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="puzzleNumberSquare"
        @save="save"
        @generate="generate"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import PuzzleNumberSquareForm from './PuzzleNumberSquareForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_PUZZLE_NUMBER_SQUARE_MODEL_, MODEL } from './PuzzleNumberSquareModel';

export default {
  name: 'puzzle-number-square-page',
  components: {
    PuzzleNumberSquareForm,
    SidebarActions,
  },
  computed: {
    puzzleNumberSquare() {
      const { puzzleNumberSquare } = this.$store.state.numberSquare;
      if (puzzleNumberSquare) {
        Events.$emit(_LOAD_PUZZLE_NUMBER_SQUARE_MODEL_, puzzleNumberSquare);
        return puzzleNumberSquare;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    generate() {
      this.$refs.puzzleNumberSquareForm.generate();
    },
    save() {
      this.$refs.puzzleNumberSquareForm.save();
    },
  },
};
</script>
